const BulkCreateItem = () => import("@/views/item/BulkCreateItem.vue");
const CreateItem = () => import("@/views/item/CreateItem.vue");
const EditItem = () => import("@/views/item/EditItem.vue");
const CopyItem = () => import("@/views/item/CopyItem.vue");
const ViewItem = () => import("@/views/item/ViewItem.vue");
const Item = () => import("@/views/item/Item.vue");

const TYPE = "ADMIN";

export default {
  path: "item",
  meta: { label: "Item" },
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      name: "Item List",
      component: Item,
      meta: {
        requiresAuth: true,
        type: TYPE,
      },
    },
    {
      path: ":id?",
      meta: {
        label: "Edit",
        requiresAuth: true,
        type: TYPE,
      },
      name: "Item",
      component: CreateItem,
      props: {
        context: "edit",
      },
    },
    {
      path: "edit/:id",
      meta: {
        label: "Edit Item",
        requiresAuth: true,
        type: TYPE,
      },
      name: "EditItem",
      component: EditItem,
      props: {
        context: "edit",
      },
    },
    {
      path: "copy/:id",
      meta: {
        label: "Copy Item",
        requiresAuth: true,
        type: TYPE,
      },
      name: "CopyItem",
      component: CopyItem,
    },
    {
      path: "view/:id",
      meta: {
        label: "View",
        requiresAuth: true,
        type: TYPE,
      },
      name: "ViewItem",
      component: ViewItem,
    },
    {
      path: "create",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: ":id",
          name: "CreateItem",
          meta: {
            label: "Create Item",
            requiresAuth: true,
            type: TYPE,
          },
          component: CreateItem,
        },
      ],
    },
    {
      path: "bulk",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "create/:id",
          meta: {
            label: "Bulk Create",
            requiresAuth: true,
            type: TYPE,
          },
          name: "Bulkcreate",
          component: BulkCreateItem,
        },
      ],
    },
  ],
};
